import styled from '@emotion/styled'

export const Content = styled.div`
	color: ${({ theme }) => theme.colors.gray[700]};
	font-size: 16px;
	font-weight: 300;
	line-height: 1.5rem;
	margin: 2rem 0 4rem;

	a {
		color: ${({ theme }) => theme.colors.contentLink};
	}
	h1,
	h2 {
		font-weight: 300;
		line-height: 2rem;
	}
	h3,
	h4 {
		font-weight: 400;
		margin: 16px 0 8px;
	}
	strong {
		font-weight: 700;
	}
	em {
		font-style: italic;
	}

	h2 {
		margin: 35px 0 0 0;
	}

	.aligncenter {
		display: block;
		margin-right: auto;
		margin-left: auto;
	}
	.alignleft {
		float: left;
		margin: 10px 25px 10px 0;
	}
	.alignright {
		float: right;
		margin: 10px 0 10px 15px;
	}
	img {
		height: auto;
		width: 100%;
	}

	.small,
	.med,
	.full {
		width: 100%;
	}

	blockquote {
		margin: auto;
		width: 90%;
	}

	figure figcaption {
		clear: both;
		text-align: center;
		font-style: italic;
		line-height: 1.35em;
	}

	figure .attributionLink {
		text-align: center;
	}

	p > picture.thumb img,
	img.thumb,
	figure.thumb {
		width: 100%;
	}

	/* tables */
	table {
		border-collapse: collapse;
		display: block;
		overflow-x: auto;
		padding-bottom: 1rem;
		position: relative;
		width: 100%;

		::-webkit-scrollbar {
			-webkit-overflow-scrolling: auto;
			-webkit-appearance: none;
			background: #f3f3f3;
			border-radius: 10px;
			height: 8px;
		}
		::-webkit-scrollbar-thumb {
			border-radius: 10px;
			background-color: ${({ theme }) => theme.colors.gray[200]};
		}
	}

	tbody,
	td,
	tfoot,
	th,
	thead,
	time,
	tr,
	tt {
		border-collapse: collapse;
		border-spacing: 0;
		border-style: solid;
		border-width: 1px;
		vertical-align: inherit;
	}

	td {
		padding: 1rem;
	}

	.ba {
		border-style: solid;
		border-width: 1px;
	}

	.pa3 {
		padding: 1rem;
	}

	@media screen and (min-width: 800px) {
		p > picture.thumb img,
		img.thumb,
		figure.thumb {
			width: 150px;
		}
	}

	${({ theme }) => theme.MQ.M} {
		.small {
			width: 38%;
		}
		.med {
			width: 62%;
		}
	}

	/*  Methodology Cards  */
	/* .methodologyCards {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: space-around;
		margin: 0 auto;
		padding: 0;
	}
	.mCard {
		margin-top: 2rem;
		width: 49%;
	}
	.mCard-badge {
		text-align: center;
	}
	.mCard-badge img {
		width: 80px;
		height: 95px;
	}
	.mCard-title {
		font-family: PT Sans;
		font-size: 20px;
		color: #17a6ff;
		text-align: center;
		margin: 35px 0 23px;
	}
	.mCard-desc {
		font-family: PT Sans;
		font-size: 15px;
		color: #5e95ba;
		margin: 0 50px;
	} */

	/*  Methodology cards  */
	.methodologyWrapper {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: space-around;
		margin: 0 auto;
		padding: 0;
		.methodologyFocus {
			font-family: PT Sans;
			margin: 20px 0;
			text-align: center;
			width: 50%;
		}
		.methodologyLogo {
			margin-bottom: 20px;
			img {
				height: 80px;
				width: 80px;
			}
		}
		.methodologyTitle {
			color: #17a6ff;
			font-size: 20px;
			margin-bottom: 20px;
		}
		.methodologyDesc {
			margin: 0 auto;
			width: 75%;
			p {
				color: #5e95ba;
				font-size: 15px;
				line-height: 2;
				text-align: left;
			}
		}
	}
	.methodologyCards {
		display: -ms-flexbox;
		display: flex;
		-ms-flex-direction: row;
		flex-direction: row;
		-ms-flex-wrap: wrap;
		flex-wrap: wrap;
		-ms-flex-pack: distribute;
		justify-content: space-around;
		margin: 0 auto;
		padding: 0;
	}
	.methodologyCards .mCard {
		margin-top: 60px;
		width: 49%;
	}
	.methodologyCards .mCard .mCard-badge {
		text-align: center;
	}
	.methodologyCards .mCard .mCard-badge img {
		width: 80px;
		height: 95px;
	}
	.methodologyCards .mCard .mCard-title {
		font-family: PT Sans;
		font-size: 20px;
		color: #17a6ff;
		text-align: center;
		margin: 35px 0 23px;
	}
	.methodologyCards .mCard .mCard-desc {
		font-family: PT Sans;
		font-size: 15px;
		color: #5e95ba;
		margin: 0 50px;
	}
	@media only screen and (max-width: 614px) {
		/*  Methodology Cards  */
		.methodologyCards .mCard {
			margin-top: 50px;
			width: 95%;
		}
	}
	@media only screen and (max-width: 450px) {
		.methodologyCards .mCard {
			width: 100%;
		}
		.methodologyCards .mCard .mCard-desc {
			width: 100%;
			margin: 0;
		}
	}
`
